<template>
  <div class="popup-box flex flex-column" style="position: relative">
    <ul class="form-box">
      <el-form :model="state.model" ref="formDom">
        <div style="font-weight: 600; font-size: 13px; margin-bottom: 10px">
          基本信息
        </div>
        <div class="info-form">
          <el-form-item label="状态">
            <el-switch
              v-model="state.model.status"
              inline-prompt
              active-text="正常"
              active-color="#1e90ff"
              inactive-text="停用"
              inactive-color="#f00"
              :active-value="1"
              :inactive-value="0"
              style="--el-switch-off-color: #f00"
            />
          </el-form-item>
          <el-form-item
            label="名称"
            prop="name"
            :rules="[
              {
                required: true,
                message: '请填写名称',
                trigger: 'blur',
              },
            ]"
          >
            <el-input v-model="state.model.name"></el-input>
          </el-form-item>
          <el-form-item
            label="联系人姓名"
            prop="contact_name"
            :rules="[
              {
                required: true,
                message: '请填写联系人姓名',
                trigger: 'blur',
              },
            ]"
          >
            <el-input v-model="state.model.contact_name"></el-input>
          </el-form-item>
          <el-form-item
            label="职位"
            prop="contact_job"
            :rules="[
              {
                required: true,
                message: '请填写职位',
                trigger: 'blur',
              },
            ]"
          >
            <el-input v-model="state.model.contact_job"></el-input>
          </el-form-item>
          <el-form-item
            label="联系方式"
            prop="contact_phone"
            :rules="[
              {
                required: true,
                message: '请填写联系方式',
                trigger: 'blur',
              },
              {
                validator: phone_rules,
                trigger: 'blur',
              },
            ]"
          >
            <el-input
              v-model="state.model.contact_phone"
              type="number"
            ></el-input>
          </el-form-item>
          <el-form-item
            label="邮箱"
            prop="contact_email"
            :rules="[
              {
                validator: email_rules,
                trigger: 'blur',
              },
            ]"
          >
            <el-input v-model="state.model.contact_email"></el-input>
          </el-form-item>
          <el-form-item
            label="服务费计算方式"
            prop="service_cost"
            style="width: 100%"
          >
            <el-config-provider
              :value-on-clear="null"
              :empty-values="[undefined, null]"
            >
              <el-select
                v-model="state.model.service_cost_type"
                placeholder="收费类型"
                style="width: 120px; margin-left: 5px"
              >
                <el-option label="无" :value="0" />
                <el-option label="每人每月" :value="1" />
                <el-option label="每人每笔" :value="2" />
              </el-select>
            </el-config-provider>
            <el-input-number
              v-model="state.model.service_cost"
              :controls="false"
              class="number-input-left number-input-suffix"
              :precision="2"
              suffix="元"
              style="width: 200px; margin-left: 5px"
            ></el-input-number>
          </el-form-item>
          <el-form-item
            label="所属地区"
            prop="district"
            :rules="[
              {
                required: true,
                message: '请选择地区',
                trigger: 'blur',
              },
            ]"
          >
            <el-cascader
              v-model="state.model.area"
              :options="state.areaData"
              :props="{ label: 'name', value: 'name' }"
              placeholder="--所属地区--"
              style="width: 100%"
              clearable
              filterable
              @change="onAreaChange"
            />
          </el-form-item>
          <el-form-item
            label="所在地址"
            prop="address"
            :rules="[
              {
                required: true,
                message: '请填写所在地址',
                trigger: 'blur',
              },
            ]"
            style="width: 66.66%"
          >
            <el-input v-model="state.model.address"></el-input
          ></el-form-item>
        </div>
        <div style="font-weight: 600; font-size: 13px; margin: 10px 0">
          收款信息
        </div>
        <div class="info-form">
          <el-form-item
            label="户名"
            prop="bank_account_name"
            :rules="[
              {
                required: state.model.is_diff_bank,
                message: '请填写户名',
                trigger: 'blur',
              },
            ]"
          >
            <el-input v-model="state.model.bank_account_name" />
          </el-form-item>
          <el-form-item
            label="开户行"
            prop="opening_bank"
            :rules="[
              { required: true, message: '请填写开户行', trigger: 'blur' },
            ]"
          >
            <el-input v-model="state.model.opening_bank" />
          </el-form-item>
          <el-form-item
            label="账号"
            prop="bank_account"
            :rules="[
              { required: true, message: '请填写账号', trigger: 'blur' },
            ]"
          >
            <el-input v-model="state.model.bank_account" />
          </el-form-item>
        </div>
      </el-form>
    </ul>
    <ul class="submit-box">
      <el-button type="primary" @click="onSubmit">提交</el-button>
    </ul>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { data_areacode_tree } from "@/http/data";
import {
  settleunit_add,
  settleunit_detail,
  settleunit_edit,
} from "@/http/supplier";
import { post_response } from "@/utils/qFormat";
import { ElMessage } from "element-plus";
import { phone_rules, email_rules } from "@/utils/rules";
import constant from "@/utils/constant.js";

export default {
  props: {
    id: Number,
    supplier_id: Number,
  },
  setup(props, { emit }) {
    const formDom = ref(null);
    const state = reactive({
      model: {
        status: 1,
        service_cost_type: 0,
      },
    });
    onMounted(() => {
      onLoadAreaCode();

      if (props.id) {
        settleunit_detail(props.id).then((res) => {
          if (res.status == 200) {
            state.model = res.data.data;

            if (state.model.district) {
              state.model.area = [
                state.model.province,
                state.model.city,
                state.model.district,
              ];
            }
          }
        });
      }
    });

    const onLoadAreaCode = () => {
      data_areacode_tree().then((res) => {
        if (res.status == 200) state.areaData = res.data.data?.list;
      });
    };

    const onAreaChange = (value) => {
      if (value.length == 3) {
        state.model.province = value[0];
        state.model.city = value[1];
        state.model.district = value[2];
      }
    };

    const onSubmit = () => {
      formDom.value.validate((valid, rules) => {
        if (valid) {
          if (props.id) {
            settleunit_edit(state.model).then((res) => {
              post_response(res, emit);
            });
          } else {
            state.model.supplier_id = props.supplier_id;

            settleunit_add(state.model).then((res) => {
              post_response(res, emit);
            });
          }
        } else {
          ElMessage({
            type: "warning",
            grouping: true,
            message: rules[Object.keys(rules)[0]][0]?.message,
          });
        }
      });
    };
    return {
      state,
      props,
      formDom,
      onSubmit,
      phone_rules,
      email_rules,
      onAreaChange,
      constant,
    };
  },
};
</script>
<style scoped lang="less"></style>
